import React from 'react';
import { ContentLayout } from 'layout/content';
import { DossierSummaryContainer } from 'pods/dossier/summary';
export const DossierSummaryScene = () => {
    return (React.createElement(ContentLayout, null,
        React.createElement(DossierSummaryContainer, null)));
};
